import {SmartComponent} from "smart-component-js";

class FormIdComponent extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.init();
    }

    init() {
        const idAgency = this.getQueryParam("agencyId");
        const idProduct = this.getQueryParam("productId");
        const idCategory = this.getQueryParam("categoryId");  // todo

        document.addEventListener('yxp-form-loaded', () => {
            const agencyId = document.querySelector('form input[name="AgencyId"]');
            agencyId.value = idAgency

            const productId = document.querySelector('form input[name="ProductId"]');
            if (idProduct) {
                productId.value = idProduct
            }

            if (idCategory) this.addOptionServiceListener(idCategory); // todo
        })
    }


    addOptionServiceListener(idCategory) {
        let argumentFieldListened = false;
        const selectRequestInput = document.querySelector('form select[name="selectRequest"]');

        console.log("selectRequestInput", selectRequestInput);
        selectRequestInput.value = "35";

        selectRequestInput.dispatchEvent(new Event('change'));

        document.addEventListener('yxp-form-options-service-ok', (e) => {
            if (argumentFieldListened && e.detail.config?.attrName === 'argument') return;
            const argument = document.querySelector('form select[name="argument"]');
            console.log("argument", e.detail);
            const argumentSelect = e.detail.config.options.find(option => option.data == idCategory);
            if (argumentSelect) {
                argument.value = argumentSelect.value;
            }

            // set input value Argomento in base all'attributo nell'url "categoryId"

            argumentFieldListened = true;
        });
    }

    getQueryParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }
}

export default FormIdComponent;